import { Badge, Box, Stack, Text } from "@chakra-ui/core";
import React from "react";
import { FaStar } from "react-icons/fa";

const PopularBadge = ({ color, bg, ...props }) => {
  return (
    <Box fontSize="xs" {...props}>
      <Badge color={bg} bg={color} p={1} rounded="full">
        <Stack isInline spacing={1} align="center" shouldWrapChildren>
          <FaStar></FaStar>
          <Text as="span">Popularny</Text>
        </Stack>
      </Badge>
    </Box>
  );
};

export default PopularBadge;
